<util-progress [bar]="true" *ngIf="loading"></util-progress>
<div class="row">
  <div class="card">
    <div class="card-body">
      <h4 class="card-title">
        <img class="rounded-circle avatar-sm object-fit-cover" src="{{leaderboard?.avatar}}" alt="Leaderboard"/>
        &nbsp;Leaderboard
      </h4>
      <h6 class="card-subtitle font-14 text-muted">
        <a href="javascript:void(0);" [routerLink]="['/u/' + username]">@{{ username }}</a>
        <p class="card-text text-warning mt-2">Redeemable point updates every 100 threshold.</p>
      </h6>
    </div>
    <div class="card-body col-12">
      <table class="table">
        <tbody>
        <tr>
          <td>
            <div class="text-center">
              <h3>{{ leaderboard?.points }}</h3>
              <h5>Points</h5>
            </div>
          </td>
          <td>
            <div *ngIf="isMyProfile()" class="text-center">
              <h3>
<!--                {{ wallet?.loyalty_points }}-->
              </h3>
              <div (click)="showLoyaltyPointHint()">
                <h5>Redeemable</h5>
                <i>(?)</i>
              </div>
            </div>
            <div *ngIf="!isMyProfile()" class="text-center">
              <h3>{{ getCurrentBadgeTitle() }}</h3>
              <h5>Achieved Badge</h5>
            </div>
          </td>
        </tr>

        <tr>
          <td>
            <div class="text-center">
              <h3>{{ getRedeemedAmount() }}</h3>
              <h5>Total Redeemed</h5>
            </div>
          </td>
          <td>
            <div class="text-center">
              <h3>{{ getBadgeCount() }}</h3>
              <h5>No of Badges</h5>
            </div>
          </td>
        </tr>

        </tbody>
      </table>

    </div>

    <div class="card-body">
      <div class="float-end">
        <a href="javascript: void(0);" class="card-link text-danger pe-3" (click)="onCloseClick()">Close</a>
        <a href="javascript: void(0);" class="card-link text-primary pe-3"
           (click)="showRecentTransactions=!showRecentTransactions">Transactions</a>
        <a href="javascript: void(0);" class="btn btn-outline-info waves-effect waves-light" *ngIf="isMyProfile()"
           (click)="openRedeemDialog()">Redeem</a>
      </div>
    </div>
  </div>
</div>

<div class="row" *ngIf="showRecentTransactions">
  <div class="card">
    <div class="card-body">

      <h4 class="card-title">Recent Transactions</h4>

      <div class="table-responsive">
        <div class="table table-bordered table-striped table-nowrap mb-0" *ngIf="showRecentTransactions">
          <table class="table table-condensed mt-2">
            <thead>
            <tr>
              <th>Date</th>
              <th>Desc.</th>
              <th>Amount</th>
              <th>Type</th>
              <th>Tnx</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let t of wallet?.recent_transactions">
              <td>{{ t.created_at | date:'dd-MM-yyyy hh:m:s' }}</td>
              <td>{{ t.description }}</td>
              <td>{{ t.amount }}</td>
              <td>{{ t.type }}</td>
              <td>{{ t.trnx_id }} <span class="btn-copy" (click)="copyToClipboard(t.trnx_id)">COPY</span></td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

  </div>
</div>

